import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import appParameters from '../../components/utils/AppParameters';
import { changeContextMode, hideMenus, showSavePreloader } from '../../actions/MenuActions';
import menuType from '../../constants/MenuType';
import properties from '../../constants/Properties';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import configuration from '../../constants/Configuration';
import modeType from '../../constants/ModeConstants';

const ClipartSelectorButtonNewContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        if (this.isAvailable() == false)
            return;

        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        if (this.isAvailable() == false)
            return;

        this.setState({
            isOver: false
        });
    },
    onMouseDown(e) {
        if (this.isAvailable() == false)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onMouseUp(e) {
        if (this.isAvailable() == false)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.changeUniverse();
    },
    onClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.changeUniverse();
    },
    changeUniverse() {
        var currentTheme = appParameters.currentTheme;

        if (currentTheme != this.props.item.name) {
            masterUniverseUtils.changeTheme(this.props.item.name);
            this.props.dispatch(showSavePreloader(true));
        }

        this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
        this.props.dispatch(hideMenus([menuType.UNIVERSES_MENU]));

        mouseUtils.setFocusSequence();
    },
    isAvailable() {
        if (configuration.LOAD_LOCAL)
            return true;

        // if ((configuration.IS_PROD() && this.props.item.hidden == 2) || (!configuration.IS_PROD() && this.props.item.hidden == 1))
        if (this.props.item.hidden > 0)
            return true;
        else
            return false;
    },
    getTitle() {
        var item  = this.props.item;

        if (!item.translations)
            return item.name;
        else {
            var translation = item.translations[masterUniverseUtils.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (item.translations['en_US'])
                return item.translations['en_US'];
            else
                return item.name;
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var buttonColor;
        var textColor;

        if (this.state.isOver == true) {
            buttonColor = properties.BROWSER_HOVER_COLOR;
            textColor = '#2299D6';
        } else {
            buttonColor = properties.BROWSER_COLOR;
            textColor = '#000000';
        }

        if (this.isAvailable() == false) {
            buttonColor = 'lightgrey';
            textColor = 'white';
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth,
            height: properties.UNIVERSE_BUTTON_HEIGHT,
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: this.props.index * properties.UNIVERSE_BUTTON_HEIGHT,
            color: 'white',
            margin: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            paddingRight: 0,
            paddingBottom: 0,
            paddingTop: 0
        };

        const spanStyle = {
            position: 'absolute',
            color: textColor,
            fontSize: 15,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            top: 9
        };

        var iconVisible;

        if (this.props.item.name == appParameters.currentTheme)
            iconVisible = 'block';
        else
            iconVisible = 'none';

        const iconStyle = {
            position: 'absolute',
            top: 11,
            right: 60,
            color: textColor,
            display: iconVisible
        };

        var idValue;

        if (this.props.index == 0)
            idValue = 'firstThemeElement';

        return (
            <button id={idValue} aria-label={this.getTitle()} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onClick={this.onClick} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp}>
                <span style={spanStyle}>{this.getTitle()}</span>
                <i style={iconStyle} className='fa fa-check'></i>
            </button>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        accordionWidth
    };
}

export const ClipartSelectorButtonNew = connect(mapStateToProps)(ClipartSelectorButtonNewContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ClipartSelectorButtonNew.js
 **/